module.exports = __webpack_public_path__ + "static/img/14.979afd3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/4/zh/14.png
// module id = ToAf
// module chunks = 0